import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
  navIcon: ({ disabled }) => ({
    width: '43px',
    height: '20px'
  })
}));
